/**
 * Validates a file for upload by extension (and optional size).
 * @param {File} file - The file to validate
 * @param {string[]} allowedExtensions - Allowed extensions e.g. ['.png', '.jpg', '.jpeg']
 * @param {Object} options - Optional: { maxSizeInBytes }
 * @returns {{ valid: boolean, error?: string }}
 */
export const validateFileForUpload = (file, allowedExtensions = [], options = {}) => {
  if (!file || !(file instanceof File)) {
    return { valid: false, error: 'Please select a valid file.' };
  }

  const name = (file.name || '').toLowerCase();
  const hasValidExtension = allowedExtensions.some((ext) => {
    const extLower = ext.startsWith('.') ? ext.toLowerCase() : `.${ext.toLowerCase()}`;
    return name.endsWith(extLower);
  });

  if (!hasValidExtension) {
    return {
      valid: false,
      error: `Invalid file type. Allowed: ${allowedExtensions.join(', ')}`
    };
  }

  const { maxSizeInBytes } = options;
  if (typeof maxSizeInBytes === 'number' && file.size > maxSizeInBytes) {
    const maxMB = (maxSizeInBytes / (1024 * 1024)).toFixed(1);
    return { valid: false, error: `File size must be less than ${maxMB} MB.` };
  }

  return { valid: true };
};
